var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.pack
    ? _c("div", [
        !_vm.pack.style_id
          ? _c("div", { staticClass: "text-center font-weight-bold" }, [
              _c("div", { staticClass: "card mb-4 box-shadow" }, [
                _c("div", { staticClass: "card-header" }, [
                  _c("h4", { staticClass: "my-0 font-weight-normal" }, [
                    _vm._v(_vm._s(_vm.pack.name)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-body" }, [
                  _c("h1", { staticClass: "card-title pricing-card-title" }, [
                    _vm.pack.price > 0
                      ? _c("del", [
                          _vm._v("$" + _vm._s(_vm.pack.default_price)),
                        ])
                      : _vm._e(),
                    _vm._v(
                      "\n                    $" +
                        _vm._s(
                          _vm.pack.price
                            ? _vm.pack.price
                            : _vm.pack.default_price
                        ) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("small", { staticClass: "font-weight-bold" }, [
                    _vm._v(_vm._s(_vm.pack.description)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "border-top pt-2",
                      staticStyle: { margin: "auto" },
                    },
                    [
                      _vm._l(_vm.pack.awards, function (award) {
                        return _c("div", { staticClass: "mb-2" }, [
                          award.value
                            ? _c("div", [
                                _c("img", {
                                  staticClass: "icon24",
                                  attrs: {
                                    title: award.text,
                                    src: `/images/` + award.icon,
                                  },
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$helpers.prettyNumber(award.value)
                                    ) +
                                    " " +
                                    _vm._s(award.text) +
                                    "\n                        "
                                ),
                              ])
                            : _vm._e(),
                        ])
                      }),
                      _vm._v(" "),
                      _vm._m(0),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.pack.token === "VIP"
                    ? _c(
                        "div",
                        { staticClass: "text-center" },
                        [
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-popover",
                                  rawName: "v-b-popover.hover.html.bottom",
                                  value: {
                                    variant: "info",
                                    content:
                                      "- Personal badge <br> - Access to VIP room <br> - Longer dig duration <br> - 6 Daily card draws <br> - Daily mysterious chests <br> - Increased chance when digging",
                                  },
                                  expression:
                                    "{ variant: 'info',  content: '- Personal badge <br> - Access to VIP room <br> - Longer dig duration <br> - 6 Daily card draws <br> - Daily mysterious chests <br> - Increased chance when digging' }",
                                  modifiers: {
                                    hover: true,
                                    html: true,
                                    bottom: true,
                                  },
                                },
                              ],
                              staticClass: "small mt-2",
                              attrs: {
                                variant: "outline-success",
                                title: "VIP Benefits",
                              },
                            },
                            [
                              _vm._v(
                                "\n                        What is VIP?\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-2" }, [
                    false
                      ? _c(
                          "a",
                          {
                            staticClass: "border rounded mt-2",
                            staticStyle: {
                              "box-shadow": "1px 1px #d1d1da",
                              background: "#d9e1fb",
                              width: "190px",
                              display: "inline-block",
                              "text-decoration": "none",
                            },
                            attrs: {
                              href:
                                "/purchase_request?method=credit-card&pack=" +
                                _vm.pack.token,
                              target: "_blank",
                            },
                          },
                          [
                            _c("img", {
                              staticStyle: { width: "42px" },
                              attrs: { src: "/images/payment/visa.jpg" },
                            }),
                            _vm._v(" "),
                            _c("img", {
                              staticStyle: { width: "42px" },
                              attrs: { src: "/images/payment/mc.png" },
                            }),
                            _vm._v(" "),
                            _c("img", {
                              staticStyle: { width: "42px" },
                              attrs: { src: "/images/payment/discover.png" },
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "/purchase_request?method=paypal&pack=" +
                            _vm.pack.token,
                          target: "_blank",
                        },
                      },
                      [
                        _c("img", {
                          attrs: { src: "/images/payment/paypal.png" },
                        }),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ])
          : _c("div", [
              _c(
                "div",
                {
                  staticClass: "holder",
                  class: {
                    "style-1": _vm.pack.style_id === 1,
                    "style-2": _vm.pack.style_id === 2,
                    "style-3": _vm.pack.style_id === 3,
                    "style-5": _vm.pack.style_id === 5,
                  },
                  style: {
                    backgroundImage:
                      "url(images/store/" + _vm.pack.bg_img + ")",
                  },
                },
                [
                  _vm.dateDiff
                    ? _c("div", { staticClass: "time" }, [
                        _c("img", {
                          attrs: { src: "/images/store/clock.png" },
                        }),
                        _vm._v(" " + _vm._s(_vm.dateDiff) + "\n            "),
                      ])
                    : _vm.pack.purchase_limit
                    ? _c("div", { staticClass: "time" }, [
                        _c("img", {
                          attrs: { src: "/images/store/clock.png" },
                        }),
                        _vm._v(
                          " Limit: 0/" +
                            _vm._s(_vm.pack.purchase_limit) +
                            "\n            "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "title" }, [
                    _c("h2", {}, [_vm._v(_vm._s(_vm.pack.name))]),
                    _vm._v(" "),
                    _c("div", { staticClass: "price" }, [
                      _vm.pack.price
                        ? _c("del", [
                            _vm._v("$" + _vm._s(_vm.pack.default_price)),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", { staticClass: "final-price" }, [
                        _vm._v(
                          "$" +
                            _vm._s(
                              _vm.pack.price
                                ? _vm.pack.price
                                : _vm.pack.default_price
                            )
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row awards" }, [
                    _c(
                      "div",
                      {
                        class: {
                          "col l": _vm.pack.style_id !== 5,
                          "col-12": _vm.pack.style_id === 5,
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "row" },
                          [
                            _vm._l(_vm.pack.awards, function (award, i) {
                              return [
                                i % 2 === 0
                                  ? _c(
                                      "div",
                                      { staticClass: "mb-1 col-6 award" },
                                      [
                                        _c("div", { staticClass: "window" }, [
                                          _c("img", {
                                            staticClass: "award-icon",
                                            attrs: {
                                              title: award.text,
                                              src: `/images/` + award.icon,
                                            },
                                          }),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "txt-container" },
                                          [
                                            _c("div", { staticClass: "txt" }, [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.$helpers.prettyNumber(
                                                      award.value
                                                    )
                                                  ) +
                                                  " " +
                                                  _vm._s(award.text) +
                                                  "\n                                    "
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            }),
                          ],
                          2
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.pack.style_id === 3
                      ? _c("div", { staticClass: "col" })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: {
                          "col r": _vm.pack.style_id !== 5,
                          "col-12": _vm.pack.style_id === 5,
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "row" },
                          [
                            _vm._l(_vm.pack.awards, function (award, i) {
                              return [
                                i % 2 !== 0
                                  ? _c(
                                      "div",
                                      { staticClass: "mb-1 col-6 award" },
                                      [
                                        _c("div", { staticClass: "window" }, [
                                          _c("img", {
                                            staticClass: "award-icon",
                                            attrs: {
                                              title: award.text,
                                              src: `/images/` + award.icon,
                                            },
                                          }),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "txt-container" },
                                          [
                                            _c("div", { staticClass: "txt" }, [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.$helpers.prettyNumber(
                                                      award.value
                                                    )
                                                  ) +
                                                  " " +
                                                  _vm._s(award.text) +
                                                  "\n                                    "
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            }),
                          ],
                          2
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 text-center" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 mt-1 text-center button-holder" },
                      [
                        _vm.source === "never"
                          ? _c(
                              "a",
                              {
                                staticClass: "chk-btn2 mt-2",
                                attrs: { target: "_blank", href: "\\packages" },
                              },
                              [_vm._v("Go To Store")]
                            )
                          : _c(
                              "a",
                              {
                                attrs: {
                                  target: "_blank",
                                  href:
                                    "/purchase_request?method=paypal&pack=" +
                                    _vm.pack.token,
                                },
                              },
                              [
                                _c("img", {
                                  staticClass: "chk-btn mt-2",
                                  attrs: { src: "/images/payment/paypal.png" },
                                }),
                              ]
                            ),
                      ]
                    ),
                  ]),
                ]
              ),
            ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-100" }, [
      _c("div", { staticClass: "small" }, [
        _vm._v("* If you already have VIP, the duration will be extended."),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "small" }, [_vm._v("* Prices are in USD")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }